import { Funnel, FunnelChart, LabelList, ResponsiveContainer, Tooltip } from "recharts"
import { useAnalysisContext } from "../../../contexts/AnalysisContext";

export const FunnelGraph = (() => {

    const { analysisTotalMetrics } = useAnalysisContext();

    const data = [
        {
          "value": analysisTotalMetrics.total_nnls,
          "name": "NNLs",
          "fill": "#8884d8"
        },
        {
          "value": analysisTotalMetrics.total_mqls,
          "name": "MQLs",
          "fill": "#83a6ed"
        },
        {
          "value": analysisTotalMetrics.total_sqls,
          "name": "SQLs",
          "fill": "#8dd1e1"
        },
        {
          "value": analysisTotalMetrics.total_pipe_count,
          "name": "Pipe Count",
          "fill": "#82ca9d"
        }
      ]
    return (
      <>
          <ResponsiveContainer width="100%" height="100%">
              <FunnelChart>
                  
                  <Tooltip />
                  <Funnel
                      dataKey="value"
                      data={data}
                      isAnimationActive
                  >
                      <LabelList position="right" fill="#000" stroke="none" dataKey="name" />
                  </Funnel>
              </FunnelChart>
          </ResponsiveContainer>
      </>
            
            
    )
})